import Skeleton from 'react-loading-skeleton';

import styles from './ModalTable.module.css';

export const ModalTable = ({
  isLoading,
  tableHeaderRow,
  isEmpty,
  children,
}: {
  isLoading: boolean;
  tableHeaderRow: React.ReactNode;
  isEmpty: boolean;
  children: React.ReactNode;
}) => {
  if (isLoading) {
    return <Skeleton count={5} />;
  }

  return (
    <table className={styles.table}>
      <thead>{tableHeaderRow}</thead>
      <tbody>
        {isEmpty ? (
          <tr>
            <td colSpan={4}>No data found.</td>
          </tr>
        ) : null}
        {!isEmpty ? children : null}
      </tbody>
    </table>
  );
};
